import { render } from "./AppGuides.vue?vue&type=template&id=1b980c0a&scoped=true"
import script from "./AppGuides.vue?vue&type=script&lang=js"
export * from "./AppGuides.vue?vue&type=script&lang=js"

import "./AppGuides.vue?vue&type=style&index=0&id=1b980c0a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b980c0a"]])

export default __exports__